import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={20}
    height={15}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.964 7.342a10.344 10.344 0 0 0-4.585-4.724l1.379-1.379a.345.345 0 0 0-.245-.585.345.345 0 0 0-.245.102L14.723 2.28A11.66 11.66 0 0 0 10 1.287 10.888 10.888 0 0 0 .036 7.341a.324.324 0 0 0 0 .297c.97 2.04 2.58 3.705 4.586 4.744l-1.38 1.379a.345.345 0 0 0 .249.586.345.345 0 0 0 .241-.104l1.545-1.537c1.487.658 3.096.996 4.723.993a10.889 10.889 0 0 0 9.964-6.061.324.324 0 0 0 0-.297ZM.726 7.493A10.216 10.216 0 0 1 10 1.977c1.44-.003 2.868.278 4.2.828l-2.028 2.027a3.447 3.447 0 0 0-5.62 2.661c.004.792.284 1.558.793 2.166l-2.213 2.213A9.709 9.709 0 0 1 .726 7.494Zm7.102 1.683A2.758 2.758 0 0 1 10 4.736c.61.003 1.202.21 1.683.585L7.828 9.176Zm4.344-3.365a2.758 2.758 0 0 1-3.854 3.847l3.854-3.847ZM10 13.01a10.882 10.882 0 0 1-4.192-.835l2.02-2.027a3.447 3.447 0 0 0 5.62-2.655 3.4 3.4 0 0 0-.793-2.172l2.213-2.206a9.707 9.707 0 0 1 4.406 4.378A10.234 10.234 0 0 1 10 13.01Z"
      fill="#1D1D1D"
    />
  </svg>
)

export default SvgComponent
